import { BAR_CHART_COLOR, DASHBOARD_COLOR_PALETTE } from './dashboard-random-palette'

/**
 * Colore unico per grafici a **barre** (dashboard, custom chart, EChart): sempre monocromatico.
 */
export const statisticsBarFillColor = BAR_CHART_COLOR

/** Palette dashboard — fallback ECharts quando colorMap non è impostato. */
export const statisticsChartsPalette = [...DASHBOARD_COLOR_PALETTE]

/** @deprecated Usare colorMap dal chart o {@link DASHBOARD_COLOR_PALETTE}. */
export const statisticsPieSeverityColors = statisticsChartsPalette.slice(8, 13)

/** @deprecated Usare colorMap dal chart o {@link DASHBOARD_COLOR_PALETTE}. */
export const statisticsPieCategoryFourColors = statisticsChartsPalette.slice(0, 4)

/**
 * Fallback per pie / line / treemap quando colorMap assente.
 */
export const statisticsTreemapColors = [...DASHBOARD_COLOR_PALETTE]

/** Gradiente mappa (choropleth): rosa chiaro → rosso scuro. */
export const statisticsMapGradientColors = [
    '#FFAAC4', '#DA7893', '#AD3C5A', '#800020',
]

/** @deprecated alias di statisticsChartsPalette */
export const chartPalette = statisticsChartsPalette

/** @deprecated alias */
export const treemapAreaTypeContrastPalette = statisticsTreemapColors
